export const BOARD_TYPE_NAME = {
  ROLE_OUT: '외래 전광판',
  ROLE_LAB: '검사 전광판',
  ROLE_SUR: '수술실 전광판',
  ROLE_PMY: '약국 전광판',
  ROLE_HEALTH: '검진 전광판',
} as const;
